module.exports = __webpack_public_path__ + "static/media/icon-ad.54e1b189.svg";